export enum ObserverNotifications {
  sendEachSignature = 1,
  sendCompletedEnvelope = 2,
  sendAllNotifications = 3
}
